export default "__VITE_PUBLIC_ASSET__b48506aa__"